"use client";

import React, { useState } from "react";
import styled, { css } from "styled-components";
import { Label } from "@motorata/base-ui.components.atoms.typography";
import Button from "@motorata/base-ui.components.atoms.button";
import { format } from "date-fns";
import pl from "date-fns/locale/pl";
import OfferModalReport from "./OfferModalReport";

const OfferContentReport = ({ mobile, dtModified }) => {
  const [modal, setModal] = useState<string | null>();

  return (
    <>
      <Wrapper mobile={mobile}>
        <Label type="third">Data modyfikacji: {format(new Date(dtModified), "do MMMM yyyy, H:mm", {
          locale: pl
        })}</Label>
        <Button type="fourth" onClick={() => setModal("report")}>
          Zgłoś naruszenie
        </Button>
      </Wrapper>
      <OfferModalReport show={modal === "report"} setShow={setModal} />
    </>
  );
};

export default OfferContentReport;

const Wrapper = styled.div<{
  mobile: boolean
}>`
  justify-content: space-between;
  margin-top: ${({ theme }) => theme.space.S};
  
  ${({ mobile }) => mobile ? css`
    display: none;
    @media (max-width: 1000px) {
      display: flex;
    }
  ` : css`
    display: flex;
    @media (max-width: 1000px) {
      display: none;
    }
  `};
`;
